// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderWrapper_loader__39mJO","showLoader":"LoaderWrapper_showLoader__3rqR-","rotate":"LoaderWrapper_rotate__1Tvf4"};